import React from 'react';
import { motion } from 'framer-motion';

export default function ContactHero() {
  return (
    <section className="relative pt-32 pb-48 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('/images/Get-in-Touch.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', // Keeps the image in place while scrolling
        }}
      />

      {/* Content Wrapper with Background Overlay for Readability */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative bg-black/60 p-10 rounded-lg max-w-3xl mx-auto"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-200">
            Have questions about our programs or want to collaborate? We're here to help.
          </p>
        </motion.div>
      </div>

      {/* Curved Bottom Edge */}
      <div className="absolute bottom-0 left-0 right-0 h-24">
        <svg className="absolute bottom-0 w-full h-full" preserveAspectRatio="none" viewBox="0 0 1440 48">
          <path
            fill="#f9fafb"
            d="M0 48h1440V0c-624 43.296-936 43.296-1440 0v48z"
          />
        </svg>
      </div>
    </section>
  );
}
